export default __webpack_public_path__ + "static/media/video.787293de.png";